import NewsTile from './NewsTile.vue';

export { NewsTile };
export default NewsTile;
